var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDoc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9976 7.58508C17.0008 7.55852 17.0008 7.53166 16.9976 7.5051C16.9647 7.3961 16.9078 7.29587 16.8309 7.21184L10.8319 1.21328C10.7396 1.10661 10.6159 1.03194 10.4786 1H10.4252H3.66627C2.95913 1 2.28095 1.28088 1.78093 1.78086C1.28091 2.28084 1 2.95895 1 3.66602V16.9961C1 17.7032 1.28091 18.3813 1.78093 18.8813C2.28095 19.3813 2.95913 19.6622 3.66627 19.6622H14.3313C15.0385 19.6622 15.7166 19.3813 16.2167 18.8813C16.7167 18.3813 16.9976 17.7032 16.9976 16.9961V7.66506C17.0006 7.63849 17.0006 7.61165 16.9976 7.58508ZM10.9985 3.27279L14.7246 6.99856H12.3316C11.9781 6.99856 11.639 6.85811 11.389 6.60812C11.1389 6.35814 10.9985 6.01908 10.9985 5.66554V3.27279ZM15.6645 16.9961C15.6645 17.3497 15.524 17.6887 15.274 17.9387C15.024 18.1887 14.6849 18.3292 14.3313 18.3292H3.66627C3.3127 18.3292 2.97361 18.1887 2.7236 17.9387C2.47359 17.6887 2.33313 17.3497 2.33313 16.9961V3.66602C2.33313 3.31249 2.47359 2.97343 2.7236 2.72344C2.97361 2.47345 3.3127 2.33301 3.66627 2.33301H9.66536V5.66554C9.66536 6.37262 9.94627 7.05073 10.4463 7.55071C10.9463 8.05068 11.6245 8.33157 12.3316 8.33157H15.6645V16.9961Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/doc.519c33b1f4db8e5f3bf1ea0c7455d3b0.svg";